import React from "react";
import { Link } from "react-router-dom";
import {
  Pill,
  FileText,
  ShoppingBag,
  HeartPulse,
  Sparkles,
  Baby,
  Dumbbell,
  Droplet,
  Leaf,
  Heart,
  Monitor,
  BriefcaseMedical,
  PawPrint,
  ChevronRight,
} from "lucide-react";
import { sidebarCategories } from "../mock";

const iconMap = {
  Pill,
  FileText,
  ShoppingBag,
  HeartPulse,
  Sparkles,
  Baby,
  Dumbbell,
  Droplet,
  Leaf,
  Heart,
  Monitor,
  BriefcaseMedical,
  PawPrint,
};

const Sidebar = () => {
  return (
    <div className="bg-white border border-gray-150 rounded-xl overflow-hidden shadow-sm">
      <div className="px-4 pt-4 pb-2 text-[15px] font-bold text-gray-800">
        Shop by Category
      </div>
      <div className="pb-2">
        {sidebarCategories.map((item) => {
          const Icon = iconMap[item.icon] || Pill;
          return (
            <Link
              key={item.name}
              to={item.to}
              className="group flex items-center gap-2.5 px-4 py-[9px] hover:bg-green-50 transition-colors"
            >
              <Icon size={17} className="text-[#12a150] shrink-0" strokeWidth={1.9} />
              <span className="flex-1 text-[13px] text-gray-700 group-hover:text-[#0e7a3d] font-medium">
                {item.name}
              </span>
              <ChevronRight
                size={14}
                className="text-gray-300 group-hover:text-[#12a150] group-hover:translate-x-0.5 transition-transform"
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
